exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".history{margin:2rem auto;max-width:150px;position:relative}.history .line{position:absolute;z-index:3;left:49%;width:3px;height:100%;background:#19596c}.history .turn{position:relative;z-index:6;margin-bottom:1rem;width:3rem;height:3rem;line-height:3rem;border-radius:50%;text-align:center;background:#19596c;color:#77c97c}.history .turn.editing{background:#77c97b;background:radial-gradient(#b4e857,#4f9853);color:#143e4a;font-weight:700}.theme-hot .history .turn.turn.editing{background:#e06b1e;background:radial-gradient(#ffc107,#e06b1e)}", ""]);

// exports
